export const dropbox = () => (
  <path
    fill="#0061FF"
    d="m12.012 7.428-4.59 2.927 4.59 2.928-4.59 2.928-4.589-2.944 4.59-2.928-4.59-2.911L7.423 4.5zm-4.613 9.724 4.59-2.927 4.588 2.927-4.589 2.928zm4.613-3.885 4.59-2.928-4.59-2.911L16.577 4.5l4.59 2.928-4.59 2.927 4.59 2.928-4.59 2.928z"
  />
);
